import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { X } from 'lucide-react';

// Styles mirror the prototype's EmailChipsInput (schedule-email-dialog.jsx):
// bordered rounded-[8px] container with focus ring, surface-1 chips with an
// 11px X, and an inline borderless input.
export function ChipInput({
  id,
  label,
  helperText,
  error,
  values,
  setValues,
  placeholder = '',
}) {
  const [inputValue, setInputValue] = useState('');

  const handleAddValue = (event) => {
    if ((event.key === 'Enter' || event.key === ',') && inputValue.trim()) {
      const newValues = inputValue.split(',').map((value) => value.trim()).filter((value) => value);
      setValues([...values, ...newValues]);
      setInputValue('');
      event.preventDefault();
    } else if (event.key === 'Backspace' && !inputValue && values.length > 0) {
      setValues(values.slice(0, -1));
    }
  };

  const handleDeleteValue = (valueToDelete) => {
    setValues(values.filter((value) => value !== valueToDelete));
  };

  return (
    <div>
      {label && (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label htmlFor={id} className="block text-sm font-medium text-ink-900 mb-1.5">
          {label}
        </label>
      )}
      <div className={'w-full flex flex-wrap items-center gap-1 px-2 py-1.5 min-h-[42px] '
        + 'border border-rule rounded-[8px] bg-white focus-within:border-brand-500 '
        + 'focus-within:ring-2 focus-within:ring-brand-500/20 transition'}
      >
        {values.map((value) => (
          <span
            key={value}
            className={'inline-flex items-center gap-1 pl-2 pr-1 py-0.5 bg-surface-1 '
              + 'rounded text-xs font-medium text-ink-900'}
          >
            {value}
            <button
              type="button"
              onClick={() => handleDeleteValue(value)}
              className="rounded-full hover:bg-ink-500/10 transition bg-transparent border-0 p-0"
              aria-label={`Remove ${value}`}
            >
              <X size={11} />
            </button>
          </span>
        ))}
        <input
          id={id}
          type="email"
          value={inputValue}
          onChange={(event) => setInputValue(event.target.value)}
          onKeyDown={handleAddValue}
          placeholder={values.length === 0 ? placeholder : ''}
          autoComplete="off"
          className={'flex-1 min-w-[140px] outline-none bg-transparent text-sm '
            + 'text-ink-900 placeholder:text-ink-500 border-0 p-0'}
        />
      </div>
      {helperText && (
        <p className={`text-[11px] mt-1 mb-0 ${error ? 'text-red-600' : 'text-ink-500'}`}>
          {helperText}
        </p>
      )}
    </div>
  );
}

ChipInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  setValues: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
